import { JSX } from 'react'

import { LogOut } from 'lucide-react'

import { OrgSelectorActionIcon } from '~/components/Layout/OrgSelector'
import { OrgSelectorDialogMenuItem } from '~/components/Layout/OrgSelectorDialogMenuItem'
import { DropdownMenuItem } from '~/components/component-library/Dropdown'
import { useLogout } from '~/hooks/useLogout'
import { useIsMobile } from '~/utils/devices'

export const LogoutButton = (): JSX.Element => {
  const logout = useLogout()
  const isMobile = useIsMobile()
  const ItemComponent = isMobile ? OrgSelectorDialogMenuItem : DropdownMenuItem

  return (
    <ItemComponent onClick={logout}>
      <div className="flex items-center space-x-2">
        <OrgSelectorActionIcon>
          <LogOut className="h-5 w-5 text-secondary md:h-3.5 md:w-3.5" />
        </OrgSelectorActionIcon>
        <div>Log out</div>
      </div>
    </ItemComponent>
  )
}
